import { render, staticRenderFns } from "./Marketing.vue?vue&type=template&id=2b3a4fb2&scoped=true&"
import script from "./Marketing.vue?vue&type=script&lang=js&"
export * from "./Marketing.vue?vue&type=script&lang=js&"
import style0 from "./Marketing.vue?vue&type=style&index=0&id=2b3a4fb2&scoped=true&lang=less&"
import style1 from "./Marketing.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3a4fb2",
  null
  
)

export default component.exports